import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ObjectStructures/constants";

export const initObjectStructuresModule = createAction(`${moduleSlug}/OBJECT_STRUCTURES_MODULE`);